import React, { useState, useEffect } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import Select from 'react-select';

import { useModal } from '../providers/modal-provider.js';
import { getCookie } from '../common_component/cookie.js';
import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import PageError from "../common_component/PageError.js";

export const EcommerceSettings = () => {
    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);

    const [state, setstate] = useState(2);
    const { openModal, setModalView, setModalData } = useModal()

    const [navtype, setnavtype] = useState("Common settings");
    const [defaultSettings, setDefaultSettings] = useState([]);
    const [dataFlag, setDataFlag] = useState(false);
    const [unique_id, setunique_id] = useState("");

    const [tempProfile, setTempProfile] = useState([]);
    const [newProfile, setNewProfile] = useState({ settings: [] });

    const [branchList, setBranchlist] = useState([]);
    const [transactionSeriesList, setTransactionSeriesList] = useState([]);

    const [warehouseList, setWarehouseList] = useState([]);
    const [stockSettings, setStockSettings] = useState(null);
    const [seriesSettings, setSeriesSettings] = useState(null);
    const [orderSettings, setOrderSettings] = useState(null);
    const [mailSettings, setMailSettings] = useState(null);
    const [deliveryZones, setDeliveryZones] = useState({check_delivery_zones: false, delivery_zone_data: []})

    const [Currency_symbol, setCurrency_symbol] = useState("");
    const [Decimal_place, setDecimal_place] = useState("");

    const { theme, dropdownStyleDark } = useTheme();

    var page_name = "ecommerce-settings";

    const { user, read, write, visibility, organization_id } = useAuthData(page_name);

    const warehouseTypeList = ["All warehouse", "Specific warehouse"];
    const shippingTypeList = ["Shipping free", "Flat shpping Fee", "Depends on cart amount", "Depends on product count"];
    const conditinalOptions = [
        { label: "Greater Than", value: "greater_than" },
        { label: "Less Than", value: "less_than" },
        { label: "Equal To", value: "equal_to" }
    ];

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    const findMissingObjects = (arr1, arr2, uniqueKey) => {
        const objMap = arr2.reduce((map, obj) => {
            map[obj[uniqueKey]] = obj;
            return map;
        }, {});

        return arr1.reduce((missing, obj) => {
            if (!objMap.hasOwnProperty(obj[uniqueKey])) {
                missing.push(obj);
            }
            return missing;
        }, []);
    };

    const handleMissingData = () => {
        let temp_settings = JSON.parse(tempProfile[0].common_settings);
        for (let i = 0; i < temp_settings.settings.length; i++) {
            const missing_items = findMissingObjects(JSON.parse(defaultSettings[0].common_settings).settings.find(x => x.key === temp_settings.settings[i].key).items, temp_settings.settings[i].items, "key");
            if (missing_items.length > 0) {
                temp_settings.settings[i].items = [...temp_settings.settings[i].items, ...missing_items]
            }

        }
        let missing_section = findMissingObjects(JSON.parse(defaultSettings[0].common_settings).settings, temp_settings.settings, "key");
        if (missing_section.length > 0) {
            temp_settings.settings = [...temp_settings.settings, ...missing_section]
        }
        setNewProfile(temp_settings);
    }

    useEffect(() => {
        if (defaultSettings.length > 0) {
            if (tempProfile.length > 0 && unique_id !== "") {
                handleMissingData();
                setOrderSettings(tempProfile[0].order_settings !== undefined && JSON.parse(tempProfile[0].order_settings))
                setStockSettings(tempProfile[0].stock_settings !== undefined && JSON.parse(tempProfile[0].stock_settings))
                setSeriesSettings(tempProfile[0].series_settings !== undefined && JSON.parse(tempProfile[0].series_settings))
                setMailSettings(tempProfile[0].mail_settings !== undefined && tempProfile[0].mail_settings)
            }
            else {
                setNewProfile(JSON.parse(defaultSettings[0].common_settings));
                setOrderSettings(JSON.parse(defaultSettings[0].order_settings));
                setStockSettings(JSON.parse(defaultSettings[0].stock_settings));
                setSeriesSettings(JSON.parse(defaultSettings[0].series_settings));
                setMailSettings(defaultSettings[0].mail_settings);
            }

            if (tempProfile.length) {
                tempProfile[0].delivery_zones === undefined ? setDeliveryZones(defaultSettings[0].delivery_zones) : setDeliveryZones(tempProfile[0].delivery_zones)
            }

            setstate(1);
        }
    }, [tempProfile, unique_id, defaultSettings]);


    async function getDefaultEcommerceSettings() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-default-ecommerce-settings`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id, "service": "expense" }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") {
            setDefaultSettings(body.data);
        }
    }

    async function getEcommerceSettings() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-ecommerce-settings`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id, "service": "expense" }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") {

            if (body.data.length > 0) {
                setTempProfile(body.data);
                setDataFlag(true);
                setunique_id(body.data[0].unique_id);
            }
        }
    }

    async function getbasecurrency() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-base-currency`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.length > 0) {
            setCurrency_symbol(body[0].currency_symbol);
            if (body[0].decimal_place != "") {
                setDecimal_place(parseInt(body[0].decimal_place));
            }
            else {
                setDecimal_place(3);
            }
        }
    }

    async function getWarehouseList() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/list-warehouse`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)
        if (body.operation == "success") {
            setWarehouseList(body.data);
        }
    }

    async function getBranchDetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-branches`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)

        if (body.operation == "success") {
            setBranchlist(body.data);
            let t = body.data.find(x => x.default_branch == "yes")
            setSeriesSettings({ ...seriesSettings, selected_branch: t.branch_id })
        }
        else {
            throw "branch list api error"
        }
    }

    async function getTransactionSeriesList() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-transaction-series-list`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)
        if (body.operation == "success") {
            setTransactionSeriesList(body.data)
        }
        else {
            throw "transaction series api list error"
        }
    }

    useEffect(() => {
        if (seriesSettings !== null && seriesSettings.selected_branch != null && transactionSeriesList.length > 0) {
            let tb = branchList.find(x => x.branch_id == seriesSettings.selected_branch)
            setSeriesSettings({ ...seriesSettings, selected_transaction_series: tb.default_transaction_series });
        }
    }, [seriesSettings?.selected_branch, transactionSeriesList])

    const updateNewPermission = (module_name, item_name, option_name, check_value, attribute_change) => {

        let temp = JSON.parse(JSON.stringify(newProfile))
        let temp2 = { settings: [] }
        temp2.settings = temp.settings.map((module) => {
            if (module_name == module.key) {
                if (item_name == undefined) {
                    return { ...module, [attribute_change]: check_value ? 1 : 0 }
                }
                else {

                    let temp3 = module.items.map((item) => {
                        if (item_name == item.key) {
                            if (option_name == undefined) {
                                return { ...item, [attribute_change]: check_value }
                            }
                        }
                        else {
                            return { ...item }
                        }
                    })
                    return { ...module, items: temp3 }
                }
            }
            else {
                return { ...module }
            }
        })

        setNewProfile(temp2)
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let parr = [
                getDefaultEcommerceSettings(),
                getbasecurrency(),
                getWarehouseList(),
                getBranchDetails(),
                getTransactionSeriesList()
            ]
            Promise.all(parr)
                .then(() => {
                    getEcommerceSettings()

                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(0);
                    console.log(err)
                })
        }
    }, [user, visibility, read, write])

    const processTitle = (title) => {
        return title.replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
    }

    const saveSettings = (flag) => {
        if (stockSettings.warehouse_type === "Specific warehouse" && stockSettings.selected_warehouse.length === 0) {
            swal("Warning!", "Please choose atleast one warehouse", "warning");
            return;
        }

        let dz = deliveryZones.delivery_zone_data
        for (let i = 0; i < dz.length; i++) {
            if (!(dz[i].delivery_zone_name.trim()) || !dz[i].lat || !dz[i].lng) {
                swal("Warning!", "Please enter all Delivery Zone details for zones", "warning")
                return
            }
        }

        let object = {};
        object.settings = JSON.stringify(newProfile);
        object.order_settings = JSON.stringify(orderSettings);
        object.stock_settings = JSON.stringify(stockSettings);
        object.series_settings = JSON.stringify(seriesSettings);
        object.mail_settings = mailSettings;
        object.delivery_zones = deliveryZones

        object.page_name = page_name;
        object.organization_id = organization_id;
        object.unique_id = unique_id;
        object.service = process.env.REACT_APP_module_name;

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        let api = "add-ecommerce-settings";
        if (dataFlag) {
            api = "update-ecommerce-settings";
        }

        setMainSubmitButtonState(true)
        axios.post(`${process.env.REACT_APP_SERVER_URL}/${api}`, object, headers).then((res) => {

            if (res.data && res.data.operation == "success") {
                setMainSubmitButtonState(false)
                swal("Great!", `All settings saved successfully!`, "success").then((value) => {
                    window.location.reload();
                });
            }
            else if (res.data.operation === "no_modification") {
                setMainSubmitButtonState(false)
                swal("Oops!", "You need to modify something for updation!!", "error");
            }
            else {
                setMainSubmitButtonState(false)
                swal("Oops!", "Something went wrong!", "error");
            }
        }).catch(function (error) {
            console.log(error)
        });

    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Ecommerce Settings</h1>
                </div>
                <div>
                    {
                        state == 1 ?
                            <>
                                <div className="card">
                                    <div className="card-header">
                                        <div className="d-flex flex-stack flex-wrap p-5">
                                            <ul className="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-n2">
                                                <li className="nav-item">
                                                    <a className={`nav-link text-active-primary pb-4 ${navtype === "Common settings" && "active"} cursor-pointer`} onClick={(e) => { setnavtype("Common settings"); }}>Common settings</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className={`nav-link text-active-primary pb-4 ${navtype === "Order settings" && "active"} cursor-pointer`} onClick={(e) => { setnavtype("Order settings"); }}>Order settings</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className={`nav-link text-active-primary pb-4 ${navtype === "Stock settings" && "active"} cursor-pointer`} onClick={(e) => { setnavtype("Stock settings"); }}>Stock settings</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className={`nav-link text-active-primary pb-4 ${navtype === "Series settings" && "active"} cursor-pointer`} onClick={(e) => { setnavtype("Series settings"); }}>Series settings</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className={`nav-link text-active-primary pb-4 ${navtype === "Mail settings" && "active"} cursor-pointer`} onClick={(e) => { setnavtype("Mail settings"); }}>Mail settings</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className={`nav-link text-active-primary pb-4 ${navtype === "Delivery Zones" && "active"} cursor-pointer`} onClick={(e) => { setnavtype("Delivery Zones"); }}>Delivery Zones</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        {
                                            navtype === "Common settings" ?
                                                <div>
                                                    <div className="d-flex flex-wrap align-items-center justify-content-center">
                                                        {newProfile.settings.length > 0 ?
                                                            <>
                                                                {newProfile.settings.map((module, index1) => {
                                                                    return (
                                                                        <div className={`card border border-border-2 rounded shadow m-3`} style={{ minHeight: "200px", minWidth: "300px" }} key={index1}>
                                                                            <div className='card-header align-items-center' style={{ minHeight: "40px", padding: "10px" }}>
                                                                                {processTitle(module.key)}
                                                                                <div className="form-check form-switch form-check-custom form-check-solid form-check-warning mt-2">
                                                                                    <input className="form-check-input w-40px h-20px" type="checkbox" checked={Boolean(module.value)} onChange={(e) => updateNewPermission(module.key, undefined, undefined, e.target.checked, "value")} />
                                                                                </div>
                                                                            </div>
                                                                            <div className=' p-5' >
                                                                                <div className='d-flex justify-content-between flex-column mb-5'>
                                                                                    {
                                                                                        module.items.map((item, index2) => {
                                                                                            if (item.input_type === "selection") {
                                                                                                return (
                                                                                                    <div className='d-flex container align-items-center justify-content-between my-2 p-0' title={processTitle(item.key)} key={index2}>
                                                                                                        <div className='d-flex container align-items-center justify-content-between my-2 p-0' title={processTitle(item.key)}>
                                                                                                            <span>{processTitle(item.key)}</span>

                                                                                                            <div className="col-md-6 fv-row">
                                                                                                                <Select
                                                                                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                                                                    className="form-select form-select-solid select2-accessible"
                                                                                                                    data-control="select2"
                                                                                                                    options={item.options.map((obj1) => { return { label: obj1, value: obj1 } })}
                                                                                                                    value={{ label: item.value, value: item.value }}
                                                                                                                    onChange={(e) => updateNewPermission(module.key, item.key, undefined, e.value, "value")}
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )
                                                                                            } else {
                                                                                                return (
                                                                                                    <div className='d-flex container align-items-center justify-content-between my-2 p-0' title={processTitle(item.key)} key={index2}>
                                                                                                        <span>{processTitle(item.key)}</span>
                                                                                                        <div className="form-check form-switch form-check-custom form-check-solid form-check-success mt-2">
                                                                                                            <input className="form-check-input w-40px h-20px" type="checkbox" checked={Boolean(item.value)} onChange={(e) => updateNewPermission(module.key, item.key, undefined, e.target.checked, "value")} />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )
                                                                                            }
                                                                                        })
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </>
                                                            :
                                                            null
                                                        }
                                                    </div>
                                                </div>
                                                :
                                                orderSettings !== null && navtype === "Order settings" ?
                                                    <>
                                                        <div className="row mb-5">
                                                            <div className="col-md-6 fv-row">
                                                                <label className="fs-5 fw-bold mb-2">Shipping Type</label>
                                                                <Select
                                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                    options={shippingTypeList.map((obj1) => { return { label: obj1, value: obj1 } })}
                                                                    onChange={(val) => {
                                                                        setOrderSettings({ ...orderSettings, shipping_type: val.value })
                                                                    }}
                                                                    value={{ label: orderSettings.shipping_type, value: orderSettings.shipping_type }}
                                                                />
                                                            </div>
                                                        </div>
                                                        {
                                                            orderSettings.shipping_type !== "Shipping free" &&
                                                            <div className="row mb-5">
                                                                <div className="col-md-4 fv-row">
                                                                    <label className="fs-5 fw-bold mb-2">Shipping Fee Applicable</label>
                                                                    <Select
                                                                        styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                        options={conditinalOptions}
                                                                        onChange={(val) => {
                                                                            setOrderSettings({ ...orderSettings, depending_condition: val.value })
                                                                        }}
                                                                        value={conditinalOptions.find(elem => elem.value == orderSettings.depending_condition)}
                                                                    />
                                                                </div>
                                                                <div className="col-md-4 fv-row">
                                                                    <label className="fs-5 fw-bold mb-2">Condition Value ({Currency_symbol})</label>
                                                                    <input className="form-control" type="number" value={orderSettings.depending_value} onChange={(e) => setOrderSettings({ ...orderSettings, depending_value: e.target.value == "" ? 0 : parseFloat(e.target.value) })} />
                                                                </div>
                                                                <div className="col-md-4 fv-row">
                                                                    <label className="fs-5 fw-bold mb-2">Shipping Charges ({Currency_symbol})</label>
                                                                    <input className="form-control" type="number" value={orderSettings.shipping_charges} onChange={(e) => setOrderSettings({ ...orderSettings, shipping_charges: e.target.value == "" ? 0 : parseFloat(e.target.value) })} />
                                                                </div>
                                                            </div>
                                                        }
                                                    </>
                                                    :
                                                    stockSettings !== null && navtype === "Stock settings" ?
                                                        <>
                                                            <div className="row mb-5">
                                                                <div className={`card border border-border-2 rounded shadow m-3`} style={{ minHeight: "100px", minWidth: "300px" }} >
                                                                    <div className='card-header align-items-center' style={{ minHeight: "40px", padding: "10px" }}>
                                                                        During Order Place
                                                                    </div>
                                                                    <div className=' p-5' >
                                                                        <div className='d-flex justify-content-between flex-column mb-5'>
                                                                            <div className='d-flex container align-items-center justify-content-between my-2 p-0' title="Allow Negative Stock">
                                                                                <span className="fs-5 fw-bold">Allow Negative Stock</span>
                                                                                <div className="form-check form-switch form-check-custom form-check-solid form-check-success mt-2">
                                                                                    <input className="form-check-input w-40px h-20px" type="checkbox" checked={stockSettings.allow_negative_stock}
                                                                                        onChange={(e) => {
                                                                                            setStockSettings({ ...stockSettings, allow_negative_stock: e.target.checked })
                                                                                        }} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className={`card border border-border-2 rounded shadow m-3`} style={{ minHeight: "150px", minWidth: "300px" }} >
                                                                    <div className='card-header align-items-center' style={{ minHeight: "40px", padding: "10px" }}>
                                                                        During Warehouse Processing
                                                                    </div>
                                                                    <div className=' p-5' >
                                                                        <div className='d-flex justify-content-between flex-column mb-5'>
                                                                            <div className="row mb-5">
                                                                                <div className="col-md-6 fv-row">
                                                                                    <label className="fs-5 fw-bold mb-2">Warehouse Type</label>
                                                                                    <Select
                                                                                        styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                                        options={warehouseTypeList.map((obj1) => { return { label: obj1, value: obj1 } })}
                                                                                        onChange={(val) => {
                                                                                            setStockSettings({ ...stockSettings, warehouse_type: val.value })
                                                                                        }}
                                                                                        value={{ label: stockSettings.warehouse_type, value: stockSettings.warehouse_type }}
                                                                                    />
                                                                                </div>
                                                                                {stockSettings.warehouse_type === "Specific warehouse" &&
                                                                                    <div className="col-md-6 fv-row">
                                                                                        <label className="fs-5 fw-bold mb-2">Selected Warehouse</label>
                                                                                        <Select
                                                                                            isMulti
                                                                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                                            options={warehouseList.map((obj1) => { return { label: obj1.name, value: obj1.wid } })}
                                                                                            onChange={(val) => {
                                                                                                setStockSettings({ ...stockSettings, selected_warehouse: val.map(obj => obj.value) })
                                                                                            }}
                                                                                            value={warehouseList.map((obj1) => { return { label: obj1.name, value: obj1.wid } }).filter(obj => stockSettings.selected_warehouse.includes(obj.value))}
                                                                                        />
                                                                                    </div>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                        :
                                                        seriesSettings !== null && navtype === "Series settings" ?
                                                            <div className="row mb-5">
                                                                <div className="col-md-6 fv-row">
                                                                    <label className="fs-5 fw-bold mb-2">Branch</label>
                                                                    <Select
                                                                        styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                        options={branchList.map((x) => { return { label: x.branch_name, value: x.branch_id } })}
                                                                        onChange={(val) => {
                                                                            setSeriesSettings({ ...seriesSettings, selected_branch: val.value })
                                                                        }}
                                                                        value={seriesSettings?.selected_branch ? branchList.map((x) => { return { label: x.branch_name, value: x.branch_id } }).find(elem => elem.value == seriesSettings?.selected_branch) : null}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6 fv-row">
                                                                    <label className="fs-5 fw-bold mb-2">Transaction Series</label>
                                                                    <Select
                                                                        styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                        options={seriesSettings?.selected_branch ? transactionSeriesList.filter(x => branchList.find(a => a.branch_id == seriesSettings?.selected_branch).transaction_series_id.split(",").includes(x.transaction_series_id)).map(x => { return { label: x.series_name, value: x.transaction_series_id } }) : []}
                                                                        onChange={(val) => {
                                                                            setSeriesSettings({ ...seriesSettings, selected_transaction_series: val.value })
                                                                        }}
                                                                        value={seriesSettings?.selected_transaction_series ? transactionSeriesList.map((x) => { return { label: x.series_name, value: x.transaction_series_id } }).find(elem => elem.value == seriesSettings?.selected_transaction_series) : null}
                                                                    />
                                                                </div>
                                                            </div>
                                                            :
                                                            mailSettings !== null && navtype === "Mail settings" ?
                                                                <div className="row mb-5">
                                                                    {
                                                                        mailSettings.map((setting, setting_index) => {
                                                                            return (
                                                                                <div className={`card border border-border-2 rounded shadow m-3`} style={{ minHeight: "200px", minWidth: "300px" }} key={setting_index} >
                                                                                    <div className='card-header align-items-center' style={{ minHeight: "40px", padding: "10px" }}>
                                                                                        {processTitle(setting.type)}
                                                                                    </div>
                                                                                    <div className=' p-5' >
                                                                                        <div className='d-flex justify-content-between flex-column mb-5'>
                                                                                            {
                                                                                                Object.keys(JSON.parse(setting.value)).map((key, index) => {
                                                                                                    return (
                                                                                                        <div className='d-flex container align-items-center justify-content-between my-2 p-0' title={processTitle(key)} key={index}>
                                                                                                            <span>{processTitle(key).toLowerCase()
                                                                                                                .split(' ')
                                                                                                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                                                                                .join(' ')
                                                                                                            }</span>
                                                                                                            <div className="form-check form-switch form-check-custom form-check-solid form-check-success mt-2">
                                                                                                                <input className="form-check-input w-40px h-20px" type="checkbox" checked={JSON.parse(setting.value)[key]}
                                                                                                                    onChange={(e) => {
                                                                                                                        let mail_arr = [...mailSettings];
                                                                                                                        let mail_obj = JSON.parse(mail_arr[setting_index].value);
                                                                                                                        mail_obj[key] = e.target.checked;
                                                                                                                        mail_arr[setting_index].value = JSON.stringify(mail_obj);
                                                                                                                        setMailSettings(mail_arr);
                                                                                                                    }} />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )
                                                                                                })
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                                :
                                                                navtype === "Delivery Zones" &&
                                                                <div className="container">
                                                                    <div className='d-flex gap-5 mb-5'>
                                                                        <div className="form-check form-switch form-check-custom form-check-solid form-check-success">
                                                                            <input className="form-check-input w-40px h-20px" type="checkbox" checked={deliveryZones.check_delivery_zones} onChange={() => setDeliveryZones({...deliveryZones, check_delivery_zones: !deliveryZones.check_delivery_zones})} />
                                                                        </div>
                                                                        <span className='text-gray-600 fs-3'>Toggle Delivery Zone checking for customers (On/Off)</span>
                                                                    </div>
                                                                    {
                                                                        deliveryZones.delivery_zone_data.map((delivery_zone, index) => {
                                                                            return (
                                                                                <div className="row align-items-center my-2" key={index}>
                                                                                    <div className='col-md-2'><span className='fs-3'>Zone {index + 1}#</span></div>
                                                                                    <div className='col-md-3'>
                                                                                        <input type="text" className='form-control required' placeholder="Delivery Zone Name" value={delivery_zone.delivery_zone_name} onChange={(e) => {
                                                                                            let temp = deliveryZones.delivery_zone_data.map(a => { return { ...a } })
                                                                                            temp[index].delivery_zone_name = e.target.value
                                                                                            setDeliveryZones({...deliveryZones, delivery_zone_data: temp})
                                                                                        }} />
                                                                                    </div>
                                                                                    <div className='col-md-4'>
                                                                                        {
                                                                                            (delivery_zone.delivery_zone_name && delivery_zone.lat && delivery_zone.lng) ?
                                                                                                <span className='fs-3 text-success fw-bold'>Zone Details configured</span> :
                                                                                                <span className='fs-3 text-gray-600'>Click on Open Map to add details</span>
                                                                                        }
                                                                                    </div>
                                                                                    <div className='col-md-2'>
                                                                                        <button className="btn btn-success" onClick={() => {
                                                                                            setModalData({
                                                                                                mapSubmitCallback: (data) => {
                                                                                                    let temp = deliveryZones.delivery_zone_data.map(a => { return { ...a } })
                                                                                                    temp[index].lat = data.lat
                                                                                                    temp[index].lng = data.lng
                                                                                                    temp[index].radius_km = data.radius
                                                                                                    setDeliveryZones({...deliveryZones, delivery_zone_data: temp})

                                                                                                    swal("Note", "Delivery Zone map data added successfully", "info")
                                                                                                },
                                                                                                selectedLocation: (delivery_zone.lat && delivery_zone.lng) ? { lat: delivery_zone.lat, lng: delivery_zone.lng } : null,
                                                                                                showCircleRange: true,
                                                                                                showCircleRangeControl: true,
                                                                                                circleRangeValue: delivery_zone.radius_km,
                                                                                            })
                                                                                            setModalView("GOOGLE_MAPS_MODAL")
                                                                                            openModal()
                                                                                        }}>Open Map</button>
                                                                                    </div>
                                                                                    <div className='col-md-1'>
                                                                                        <button className='btn btn-link btn-sm text-hover-danger' onClick={() => {
                                                                                            let temp = deliveryZones.delivery_zone_data.map(a => { return { ...a } })
                                                                                            temp.splice(index, 1)
                                                                                            setDeliveryZones({...deliveryZones, delivery_zone_data: temp})
                                                                                        }}>✖</button>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                    <button className='btn btn-success' onClick={() => { setDeliveryZones({...deliveryZones, delivery_zone_data: [...deliveryZones.delivery_zone_data, { delivery_zone_name: "", lat: null, lng: null, radius_km: 10 }] }) }}>+ Add Delivery Zone</button>
                                                                </div>
                                        }
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end mt-2">
                                    <button className='btn btn-primary rounded' onClick={(e) => saveSettings("add")} data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={(write == 1) && mainSubmitButtonState ? true : false}>
                                        {
                                            dataFlag ?
                                                <span className="indicator-label">Update </span> :
                                                <span className="indicator-label">Save </span>
                                        }
                                        <span className="indicator-progress">Please wait...
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </span>
                                    </button>
                                </div>
                            </>
                            :
                            state == 2 ?
                                <div className="card">
                                    <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                </div>
                                :
                                <PageError />
                    }

                </div>
            </div>
        </>
    )
}

export default EcommerceSettings;